module.exports = __webpack_public_path__ + "assets/img/nogrid-logo-black.514e7e09.png";